export const isScaModeActive = process.env.REACT_APP_IS_SCA_MODE_ACTIVE?.toLowerCase() === "true"